
const TagButton = ({ label, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`text-[12px] font-gilroy-bold leading-4 sm:text-[16px] sm:leading-6 p-3 sm:py-3 sm:px-5 rounded-[12px] w-[160px] sm:w-[210px] whitespace-nowrap ${
        isActive ? 'bg-[#020617] text-white' : 'bg-white text-black border-[1px] border-[#E2E8F0]'
      }`}
    >
      {label}
    </button>
  );
};

export default TagButton;
